import { Input } from '@/components/ui/input'
import { SearchIcon, XIcon, LoaderIcon } from 'lucide-react'
import { cn } from '@/lib/utils'
import { Button } from '@/components/ui/button'
import { useLingui } from '@lingui/react/macro'

export function SearchInput({
  className,
  onChange,
  isLoading,
  ...props
}: Omit<React.ComponentProps<'input'>, 'onChange'> & { isLoading?: boolean; onChange?: (value: string) => void }) {
  const { t } = useLingui()

  return (
    <div className="relative min-w-0 flex-1">
      <SearchIcon className="text-muted-foreground absolute top-1/2 left-3 size-4 -translate-y-1/2" />
      <Input
        {...props}
        onChange={(e) => onChange?.(e.target.value)}
        className={cn('search-input pl-9 pr-9', className)}
      />
      {isLoading ? (
        <LoaderIcon className="text-muted-foreground absolute top-1/2 right-3 size-4 -translate-y-1/2 animate-spin" />
      ) : (
        props.value && (
          <Button
            variant="ghost"
            size="icon"
            aria-label={t`Clear search`}
            onClick={() => onChange?.('')}
            className="absolute top-1/2 right-1 size-7 -translate-y-1/2"
          >
            <XIcon className="text-muted-foreground size-3.5" />
          </Button>
        )
      )}
    </div>
  )
}
